import React, { useEffect, useState } from "react";
import "../../styles/desktop/exaustores.css";
import CircleStatus from "./statusExaustor/statusExaustor";
import Cronometro from "../../assets/svg/cronometro";
import Ventilador from "../../assets/svg/ventilador";
import getUnidadesExaustor from "../../API/getUnidadesExaustor";
import saveExaustorState from "../../API/saveExaustor";
import { sendCommandFlex35 } from "../../API/AcionamentoFlex35";

function Exaustores() {
    const [exaustores, setExaustores] = useState([]);


    useEffect(() => {
        // Chamada inicial para buscar os dados dos exaustores na renderização
        getUnidadesExaustor().then(unidadesData => {
            console.log("Unidades recebidas na renderização:", unidadesData);
            setExaustores(unidadesData);
        });
    
        // Configuração do loop para atualização a cada 10 segundos
        const intervalId = setInterval(() => {
            getUnidadesExaustor().then(unidadesData => {
                console.log("Unidades atualizadas:", unidadesData);
                setExaustores(unidadesData);
            });
        }, 7000); // Executa a cada 10 segundos
    
        // Limpeza do intervalo ao desmontar o componente
        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setExaustores((prevExaustores) => 
                prevExaustores.map((exaustor) => {
                    // Atualiza o timer das unidades, se existirem
                    const updatedUnidades = exaustor.unidades.map((unidade) => {
                        if (unidade.state === "on" && unidade.timer > 0) {
                            return { ...unidade, timer: unidade.timer - 1 };
                        } else if (unidade.state === "on" && unidade.timer === 0) {
                            return { ...unidade, state: "expired" };
                        }
                        return unidade;
                    });
    
                    // Verifica apenas o status e timer do próprio exaustor para desligá-lo
                    if (exaustor.status === "on" && exaustor.timer === 0) {
                        sendCommandFlex35(exaustor.id, exaustor.off); // Envia comando OFF
                    }
    
                    return {
                        ...exaustor,
                        unidades: updatedUnidades,
                        // Mantém o status conforme o timer do exaustor e ignora o status das unidades
                        status: exaustor.timer === 0 ? "off" : exaustor.status,
                        timer: exaustor.status === "on" && exaustor.timer > 0 ? exaustor.timer - 1 : exaustor.timer
                    };
                })
            );
        }, 1000);
    
        return () => clearInterval(interval);
    }, []);
    
    
    const toggleExaustor = (id) => {
        setExaustores((prevExaustores) => {
            const updatedExaustores = prevExaustores.map((exaustor) => {
                if (exaustor.id === id) {
                    const newStatus = exaustor.status === "off" ? "on" : "off";
                    if(exaustor.status === "off") {
                        console.log(id, '  ', exaustor.on)
                        sendCommandFlex35(id, exaustor.on);
                    } else {
                        console.log(id, '  ', exaustor.off)
                        sendCommandFlex35(id, exaustor.off);
                    }
                    const updatedUnidades = exaustor.unidades.map((unidade) => {
                        return {
                            ...unidade,
                            state: newStatus === "on" ? "on" : "off",
                            timer: newStatus === "on" ? 10800 : 0
                        };
                    });

                    return { 
                        ...exaustor,
                        status: newStatus,
                        unidades: updatedUnidades,
                        timer: newStatus === "on" ? 10800 : 0
                    };
                }
                return exaustor; 
            });

            saveExaustorState(updatedExaustores);
            console.log("Exaustores atualizados:", updatedExaustores); // Verifica os exaustores atualizados
            return updatedExaustores;
        });
    };

    const unidadeActive = (exaustorId, unidadeId) => {
        setExaustores((prevExaustores) => {
            const updatedExaustores = prevExaustores.map((exaustor) => {
                if (exaustor.id === exaustorId) {
                    sendCommandFlex35(exaustor.id, exaustor.on);
                    if(exaustor.unidades.length === 0) {
                        return exaustor;
                    }
                    const updatedUnidades = exaustor.unidades.map((unidade) => {
                        if (unidade.id === unidadeId) {
                            const newState = unidade.state === "off" ? "on" : "off";
                            return {
                                ...unidade,
                                state: newState,
                                timer: newState === "on" ? 10800 : 0
                            };
                        }
                        return unidade;
                    });

                    const contador = updatedUnidades.reduce((acc, unidade) => acc + (unidade.state === "on" ? 1 : 0), 0);

                    return {
                        ...exaustor,
                        unidades: updatedUnidades,
                        status: contador > 0 ? "on" : "off",
                        timer: contador > 0 ? 10800 : 0
                    };
                }
                return exaustor;
            });

            saveExaustorState(updatedExaustores);
            console.log("Exaustores atualizados:", updatedExaustores); // Verifica os exaustores atualizados
            return updatedExaustores;
        });
    };

    const formatTime = (seconds) => {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    };

    return (
        <div className="exaustoresCampo">
            <div className="exaustores">
            {exaustores
                .slice()
                .sort((a, b) => {
                    // Primeiro, ordena alfabeticamente pelo id do exaustor
                    if (a.id < b.id) return -1;
                    if (a.id > b.id) return 1;
                    return 0;
                })
                .sort((a, b) => {
                    // Coloca exaustores sem unidades no final
                    if (a.unidades.length === 0 && b.unidades.length > 0) return 1;
                    if (a.unidades.length > 0 && b.unidades.length === 0) return -1;
                    return 0;
                })
                .map((exaustor) => (
                    <div className="exaustor" key={exaustor.id}>
                        <h2 className="titleExaustor">Exaustor {exaustor.id}</h2>
                        <div className="campoDasUnidades">
                            <div className="unidadesCampo">
                                {exaustor.unidades.length > 0 ? (
                                    exaustor.unidades
                                        .slice()
                                        .sort((a, b) => {
                                            const aId = parseInt(a.id, 10);
                                            const bId = parseInt(b.id, 10);
                                            const baseA = Math.floor(aId / 10);
                                            const baseB = Math.floor(bId / 10);
                                            if (baseA !== baseB) return baseB - baseA;
                                            return aId % 10 - bId % 10;
                                        })
                                        .map((unidade, index) => (
                                            <div className="unidade" key={`${exaustor.id}-${unidade.id}-${index}`}>
                                                <CircleStatus status={unidade.state} onClick={() => unidadeActive(exaustor.id, unidade.id)} />
                                                <p>{unidade.id}</p>
                                            </div>
                                        ))
                                ) : (
                                    <p id="nenhumaUndText">Nenhuma unidade vinculada</p>
                                )}
                            </div>
                        </div>
                        <div className="exaustorCampo">
                            <Ventilador className={exaustor.status === "on" ? "ventilador-ligado" : "ventilador-desligado"} width={"30%"} height={"85%"} />
                            <div className="exaustorTimerCampo">
                                <p className="timerText"><Cronometro className={"cronometroExaustor"} />{formatTime(exaustor.timer)}</p>
                                <button
                                    id="buttonExaustor"
                                    className={`buttonExaustor${exaustor.status === "on" ? '-desligar' : '-ligar'}`}
                                    onClick={() => toggleExaustor(exaustor.id)}
                                >{exaustor.status === "on" ? "Desligar" : "Ligar"}</button>
                            </div>
                        </div>
                    </div>
                ))}

            </div>
        </div>
    );             
}

export default Exaustores;